module.exports = __webpack_public_path__ + "static/media/background_1920-19.22fc19f2.jpg";